import * as Html from "../util/Html.ts";

Html.registerWidget('widget/select-role',{initDom:initDom})

function toggleInputBuilder(option: HTMLOptionElement, select: HTMLSelectElement, input: HTMLInputElement){
  return function(){
    if(option.selected){
      input.disabled = false;
      input.style.display = '';
      select.style.display = 'none';
    }else{
      input.disabled = true;
      select.style.display = '';
      input.style.display = 'none';
    }
  };
}

export function initDom(node: HTMLElement){
  const option = node as HTMLOptionElement;
  const select = node.parentElement as HTMLSelectElement;
  if(!select) return;

  const form = select.closest('form');
  if(!form) return;

  const extraInputSelector = node.getAttribute("data-fw-extra-input");
  if(!extraInputSelector) return;

  const input = form.querySelector(extraInputSelector) as HTMLInputElement;
  if(!input) return;

  const toggleInput = toggleInputBuilder(option, select, input);

  input.addEventListener('blur', function(){
    if(!input.disabled && input.value.trim() === ''){
      select.value = 'Unknown';
      toggleInput();
    }
  });

  select.addEventListener('change', toggleInput);
  toggleInput();
}